import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch Location list
 * @param {Object} filters
 *  @param {Number} page Page number
 *  @param {Number} size list size
 *  @param {String} name search text
 *  @param {String} sort sorting format: field;ASC|DESC
 */
const fetchLocationList = async function ({ page, size, name, sort }) {
  try {
    let filters = {
      page, size, name, sort
    }
    console.log('TCL: filters', filters)
    const res = await axios.get(urls.locationList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a location's detail
 * @param {Number} id Location Id
 */
const fetchLocationDetail = async function (id) {
  try {
    let res = await axios.get(urls.locationDetail + '/' + id)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create and edit a location detail
 * @param {Object} form location detail form
   * @param {String} form.name
   * @param {String} form.address
   * @param {Number} form.latitude
   * @param {Number} form.longitude
   * @param {Number} form.provinceId
   * @param {Number} form.cityId
   * @param {Number} form.districtId
   * @param {Number} form.subDistrictId
   * @param {Number} form.urbanVillageId
   * @param {Number} form.radius location reach radius for app
   * @param {Number} form.openingTime location's opening time
   * @param {Number} form.closingTime locations's closing time
   * @param {Number} form.locationNote location's location note ie: "Maksimum yang bisa masuk mobil CDD"
 * @param {Number} [locationId] Location id for edit/update
 */
const createEditLocation = async function (form, locationId) {
  try {
    let res
    if (locationId) {
      res = await axios.put((urls.locationDetail + '/' + locationId), form)
      return res.data
    } else {
      res = await axios.post(urls.locationDetail, form)
      return res.data
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchLocationList,
  fetchLocationDetail,
  createEditLocation,
}
